import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

interface Props {
	size?: number;
}

const Loader: React.FC<Props> = ({ size = 20 }) => (
	<Spin indicator={<LoadingOutlined style={{ fontSize: size }} spin />} />
);

export default Loader;
